import React from "react";
import Billing from "../components/billing/Billing";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function DashboardPage() {

  return (
    <div>
      <TitleUpdater />
      <Billing />
    </div>
  );
}
